/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import moment from 'moment';
import { Button, Col, Dropdown, Form, Modal, NavItem, NavLink, Row, Spinner } from 'react-bootstrap';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { usePageTitle } from '../../../../App';
import check_yellow_icon from '../../../../assets/images/check-yellow-icon.svg';
import due_file_icon from '../../../../assets/images/due-in-img.svg';
import full_qc_file_icon from '../../../../assets/images/full-qc-file-img.svg';
import legal_file_icon from '../../../../assets/images/legal-file-img.svg';
import qc_file_icon from '../../../../assets/images/qc-file-img.svg';
import star_icon from '../../../../assets/images/red-star-icon.svg';
import FAQ from '../../../../assets/pdf/FAQ.pdf';
import { CustomTable, CustomTooltips } from '../../../../components';
import { ALL_FILE_ROUTE, DASHBOARD_ROUTE, MY_FILE_ROUTE } from '../../../../constants/RouteNameConstants';
import { allFilesDashboardProofreaderTableData, myStatsTableData } from '../../../../constants/TableHeaderConstants';
import { foreignLanguageTemplate, legalCategoryTemplate } from '../../../../utils/TableCellUtils';
import { truncateString } from '../../../../utils/TruncateStringUtils';
import { getUserInfo } from '../../../../utils/UserInfoUtils';
import { proofreaderAllFilesRequest, proofreaderFilesFilterRequest } from '../../Files/AllFiles/actions';
import { myMetricsRequest, resetMyMetricsData } from '../../MyMetrics/actions';
import RatingMetrics from '../../MyMetrics/component/RatingMetrics';
import { dashboardProofreaderRequest } from '../actions';
import { resetEditorState } from '../../Editor-Copy/actions/slateDataActions';
import { getDaysDiff } from '../../Files/AllFiles/component/AllFiles';
import StatusDropdown from '../../Files/MyFiles/component/StatusDropdown';
import { Badge } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { trackEvent } from '../../../../utils/ga';

const Dashboard = ({
  setFullQcClick,
  setQcClick,
  setDueInDayClick,
  setDueInHalfDayClick,
  setLegalClick,
  setTodayWorkClick,
  filterClientData,
  setFilterClientData,
  filterVendorData,
  setFilterVendorData,
  filterLanguageData,
  setFilterLanguageData,
  filterServiceData,
  setFilterServiceData,
  handleFilter,
  handleFilterClear,
  handleCloseProofReaderAllFileFilter,
  setProofReaderAllFileFilterModal,
  proofReaderAllFileFilterModal,
  filterApiCall,
  setFilterApiCall,
  currentPage,
  setCurrentPage,
  setDashboardClick,
  dashboardClick,
  setClaimFile,
  setFilterFilesStatusData,
  filterFilesStatusData,
  isFilterApplied,
}) => {
  usePageTitle('Datagain Transcription  - Dashboard'); // Set tab title

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = getUserInfo();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [sortField, setSortField] = useState('DueIn');
  const [sortOrder, setSortOrder] = useState(1);
  const [proofReaderMyFileMetricsModal, setProofReaderMyFileMetricsModal] = useState(false);
  const [wordLimit, setWordLimit] = useState(30);
  const [wordLimitCurretWork, setWordLimitCurretWork] = useState(42);

  // Use useLocation to track route changes
  const location = useLocation();

  // Reset states on route change
  useEffect(() => {
    setRowsPerPage(5);
    setCurrentPage(0);
    setSortField('DueIn');
    setSortOrder(1);
    setFilterApiCall(false);
    setProofReaderAllFileFilterModal(false);
    setProofReaderMyFileMetricsModal(false);
    setWordLimit(30);
    setWordLimitCurretWork(42);
  }, [location]); // This effect runs on every route change

  // Api's loading
  let loadingProofreaderWidgetCount = useSelector((state) => state?.proofreaderFileCount?.loading);

  let dashboardProofreaderWidgetData = useSelector((state) => state?.proofreaderFileCount?.user?.data?.value);

  let proofreaderAllFileList = useSelector((state) => state?.proofreaderAllFilesList?.user?.data?.value);

  let proofreaderFileFilterList = useSelector((state) => state?.proofreaderFilesFilterList?.user?.data?.value);

  // Dashboard's Data
  let proofreaderAllFileTable = proofreaderAllFileList && JSON.parse(proofreaderAllFileList);

  let dashboardProofreaderFileCountData = dashboardProofreaderWidgetData && JSON.parse(dashboardProofreaderWidgetData);

  let dashboardDataFileDueHalfDay = dashboardProofreaderWidgetData && JSON.parse(dashboardProofreaderWidgetData);

  let filterDataFile = proofreaderFileFilterList && JSON.parse(proofreaderFileFilterList);

  // Api's loading
  const loading = useSelector((state) => state?.proofreaderAllFilesList?.loading);

  const handleOpenProofReaderMyFileMetrics = (id) => {
    dispatch(resetMyMetricsData());
    if (id) {
      setProofReaderMyFileMetricsModal(true);
      dispatch(myMetricsRequest(id));
    }
  };

  const handleCloseProofReaderMyFileMetrics = () => {
    setProofReaderMyFileMetricsModal(false);
  };

  const handleCopyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success('Copied to clipboard');
      })
      .catch((err) => {
        toast.error('Failed to copy to clipboard');
      });
  };

  // Table data sorting function
  const handleSortChange = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
    setCurrentPage(0);
    setFilterApiCall(true);
  };

  // Dashboard data set for use this function
  useEffect(() => {
    dispatch(dashboardProofreaderRequest());
    dispatch(
      proofreaderFilesFilterRequest({
        UserId: userInfo?.UserId,
        isMyFiles: false,
      }),
    );
    setFilterApiCall(false);
    setDashboardClick(false);
  }, [dispatch]);

  useEffect(() => {
    if (dashboardClick) {
      dispatch(dashboardProofreaderRequest());
      dispatch(
        proofreaderFilesFilterRequest({
          UserId: userInfo?.UserId,
          isMyFiles: false,
        }),
      );
      setFilterApiCall(false);
      setDashboardClick(false);
    }
  }, [dispatch, dashboardClick]);

  useEffect(() => {
    if (filterApiCall) {
      var params = {
        page: currentPage + 1,
        rowNumber: rowsPerPage,
        sortRowName: sortField,
        sortRowDirection: sortOrder === 1 ? 'asc' : 'desc',
        search: '',
        isFullQC: false,
        isQC: false,
        isLegal: false,
        isDueInaDay: false,
        isDueInaHalfDay: false,
        filter: {
          clientId: filterClientData === '' ? null : filterClientData,
          serviceType: filterServiceData,
          vendorId: filterVendorData === '' ? null : filterVendorData,
          userId: userInfo?.UserId,
          language: filterLanguageData,
          status: '',
        },
      };
      dispatch(proofreaderAllFilesRequest(params));
      setFilterApiCall(false);
    }
  }, [dispatch, currentPage, rowsPerPage, sortField, sortOrder, filterApiCall, ]);

  const handleShowProofReaderAllFileFilter = () => {
    setProofReaderAllFileFilterModal(true);
  };

  const centerToast = () => {
    toast(
      'This is level 1 vendor. Please make sure to check the entire transcript before you submit it to the client.',
      {
        position: 'top-center',
        style: {
          fontSize: '20px',
          fontWeight: 400,
        },
      },
    );
  };

  // Custom body template for action on column
  const actionTemplate = (rowData) => {
    return (
      <Button
        variant="primary"
        style={{ padding: 'auto' }}
        onClick={() => {
          if (rowData?.VendorLevel === 'Level 1') {
            centerToast();
          }
          if (rowData?.Id !== null && rowData?.Id !== undefined) {
            setClaimFile(true);
            trackEvent('file_claim', {
              file_id: rowData?.Id,
              file_name: rowData?.UserFileName,
            });
            trackEvent('work_started', {
              file_id: rowData?.Id,
              file_name: rowData?.UserFileName,
            });
            navigate(
              rowData?.Id ? `/${window.endPoint.IS_SLATE ? 'editor-copy' : 'editor'}/${rowData?.Id}` : DASHBOARD_ROUTE,
            );
            setFilterApiCall(true);
          }
        }}
      >
        Claim
      </Button>
    );
  };

  // Custom body template for all file name on column
  const proofreaderAllFilesTemplate = (rowData, { isRowHovered }) => {
    return (
      <div>
        <Dropdown as={NavItem} className="position-static">
          <Dropdown.Toggle as={NavLink} className="nav-user">
            <div className="d-flex align-items-center">
              <span className="table-folder-icon">
                <FolderOutlinedIcon className="fnt-20" />
              </span>
              <Button id="fade-button">
                <span className="table-link cursor-pointer fnt-14">
                  <CustomTooltips title={rowData?.UserFileName} placement="bottom">
                    <span className="cursor-pointer" style={{ userSelect: 'text' }}>
                      {truncateString(rowData?.UserFileName, 25)}
                    </span>{' '}
                    {rowData?.isLegal && <img src={star_icon} alt="legal" />}
                    {rowData?.IsFullQC && <img src={check_yellow_icon} alt="QC" />}
                  </CustomTooltips>
                  <CustomTooltips title="Copy to clipboard" placement="top">
                    <ContentCopyIcon
                      style={{
                        fontSize: '16px',
                        color: '#1285df',
                        cursor: 'pointer',
                        visibility: isRowHovered && rowData?.UserFileName ? 'visible' : 'hidden',
                        marginLeft: '4px',
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleCopyToClipboard(rowData?.UserFileName);
                      }}
                    />
                  </CustomTooltips>
                </span>
              </Button>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu className="file-toggle-box">
            <div className="file-info-header">
              <h6 className="fnt-16 fw-semibold mb-0">File Information</h6>
            </div>
            <ul className="file-list-ul">
              {rowData?.VendorLevel && (
                <li>
                  Vendor Level <span className="file-list-content">: {rowData?.VendorLevel}</span>
                </li>
              )}
              {rowData?.CompanyName && (
                <li>
                  Company Name <span className="file-list-content">: {rowData?.CompanyName}</span>
                </li>
              )}
              {rowData?.AudioLanguage && (
                <li>
                  Audio Language <span className="file-list-content">: {rowData?.AudioLanguage}</span>
                </li>
              )}
              {rowData?.Originalvendorname && (
                <li>
                  Original Vendor <span className="file-list-content">: {rowData?.Originalvendorname}</span>
                </li>
              )}
              {rowData?.ServiceType && (
                <li>
                  Service <span className="file-list-content">: {rowData?.ServiceType}</span>
                </li>
              )}
              {rowData?.ProjectManager && (
                <li>
                  Project Manager <span className="file-list-content">: {rowData?.ProjectManager}</span>
                </li>
              )}
              {(rowData?.VerbatimTranscription || rowData?.PII) && (
                <li>
                  Options{' '}
                  <span className="file-list-content">
                    :{' '}
                    {[rowData?.VerbatimTranscription && 'Verbatim', rowData?.PII && 'Redact']
                      .filter(Boolean)
                      .join(', ')}
                  </span>
                </li>
              )}
            </ul>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  const clientNameTemplate = (rowData, { isRowHovered }) => {
    return (
      <div>
        {rowData?.ClientName !== null ? (
          <>
            {rowData?.ClientName}
            <CustomTooltips title="Copy to clipboard" placement="top">
              <ContentCopyIcon
                style={{
                  fontSize: '16px',
                  color: '#1285df',
                  cursor: 'pointer',
                  visibility: isRowHovered && rowData?.ClientName ? 'visible' : 'hidden',
                  marginLeft: '8px',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopyToClipboard(rowData?.ClientName);
                }}
              />
            </CustomTooltips>
          </>
        ) : (
          <div>--</div>
        )}
      </div>
    );
  };

  // Custom body template for Vendor Name on column
  const vendorNameTemplate = (rowData, { isRowHovered }) => {
    return (
      <>
        {rowData?.VendorName !== null ? (
          <div
            style={{ color: '#1285df', cursor: 'pointer' }}
            onClick={() => handleOpenProofReaderMyFileMetrics(rowData?.VendorId)}
          >
            {rowData?.VendorName}
            <CustomTooltips title="Copy to clipboard" placement="top">
              <ContentCopyIcon
                style={{
                  fontSize: '16px',
                  color: '#1285df',
                  cursor: 'pointer',
                  visibility: isRowHovered && rowData?.VendorName ? 'visible' : 'hidden',
                  marginLeft: '8px',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopyToClipboard(rowData?.VendorName);
                }}
              />
            </CustomTooltips>
          </div>
        ) : (
          <div>--</div>
        )}
      </>
    );
  };

  // Custom body template for Vendor CompanyName on column
  const companyNameTemplate = (rowData) => {
    return <>{rowData?.CompanyName !== null ? <div>{rowData?.CompanyName}</div> : <div>--</div>}</>;
  };

  const dueInTemplate = (rowData) => {
    const dueDate = rowData?.DueDate;
    const formattedDate = moment(dueDate).format('MM/DD/YYYY');
    const formatDiff = () => {
      const diff = getDaysDiff(dueDate);
      if (diff === 0) return 'Today';
      else if (diff > 0) return 'In ' + diff + ' days';
      else if (diff < 0) return Math.abs(diff) + ' days ago';
    };
    return (
      <div
        style={{
          color: getDaysDiff(dueDate) < 0 ? '#ef3131' : 'unset',
          fontWeight: getDaysDiff(dueDate) === 0 ? 600 : 400,
        }}
      >
        {formatDiff()} ({formattedDate})
      </div>
    );
  };

  const statusTemplate = (rowData) => {
    const statusColors = {
      Rework: '#b76e00',
      Claimed: '#d92d20',
      ProofReading: '#316ea0',
      Proofreading: '#316ea0',
      Review: '#1a7f5a',
      Failed: '#9b0000',
      Submitted: '#5c6f00',
      InProgress: '#6b32ca',
      Uploaded: '#002855',
      Processing: '#5c4a75',
      Completed: '#47590a',
    };

    const color = statusColors[rowData?.Status];

    return <span style={{ color }}>{rowData?.Status}</span>;
  };

  // Modification table cell
  const bodyTemplates = {
    UserFileName: proofreaderAllFilesTemplate,
    ForeignLanguage: foreignLanguageTemplate,
    VendorName: vendorNameTemplate,
    ClientName: clientNameTemplate,
    Action: actionTemplate,
    CompanyName: companyNameTemplate,
    LegalCategory: legalCategoryTemplate,
    DueIn: dueInTemplate,
    Status: statusTemplate,
  };

  let loadingMetrics = useSelector((state) => state?.myMetrics?.loading);

  let myMetricsDataTable = useSelector((state) => state?.myMetrics?.user?.data?.value);

  let myMetrics = myMetricsDataTable && JSON.parse(myMetricsDataTable)?.MyMetrics;

  let ratingMetrics = myMetricsDataTable && JSON.parse(myMetricsDataTable)?.RatingMetrics;

  const [timeLeft, setTimeLeft] = useState('');
  const [timeLeftCount, setTimeLeftCount] = useState('');
  const [timeLeftMinus, setTimeLeftMinus] = useState(false);
  const targetDate = dashboardProofreaderFileCountData && dashboardProofreaderFileCountData?.TodayWork?.StaffDueDate; // Use optional chaining to avoid undefined

  useEffect(() => {
    const calculateTimeLeft = () => {
      if (!targetDate) {
        setTimeLeft('00:00:00'); // Set to "Time is up!" directly if no targetDate
        setTimeLeftCount('00:00:00'); // Set to "Time is up!" directly if no targetDate
        return;
      }

      const now = new Date();
      const dueDate = new Date(targetDate);
      const difference = dueDate - now;

      // If time has passed the target date, show how much time has passed since
      if (difference <= 0) {
        const differenceNow = now - dueDate;

        const days = Math.floor(differenceNow / (1000 * 60 * 60 * 24));
        const hours = Math.floor((differenceNow % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((differenceNow % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((differenceNow % (1000 * 60)) / 1000);

        // If previous days exist, add 24 hours for each day passed
        const totalHours = days * 24 + hours;

        // Format the time left as "Xd Xh Xm Xs"
        setTimeLeft(`${totalHours}:${minutes}:${seconds} Hrs`);
        setTimeLeftCount(`${totalHours}:${minutes}:${seconds}`);
        setTimeLeftMinus(true);
      } else {
        // Calculate remaining time before due date
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        const totalHours = days * 24 + hours;

        // Format the time left in "Xh Xm Xs"
        setTimeLeft(`${totalHours}:${minutes}:${seconds} Hrs`);
        setTimeLeftCount(`${totalHours}:${minutes}:${seconds}`);
        setTimeLeftMinus(false);
      }
    };

    // Calculate time left immediately and every second
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    // Clean up interval on component unmount
    return () => clearInterval(timer);
  }, [targetDate]);

  const [overTimeNear, setOverTimeNear] = useState(false);

  // Convert "H:mm:ss" to total seconds
  const convertTimeToSeconds = (timeStr) => {
    const [hours, minutes, seconds] = timeStr.split(':').map(Number);
    return hours * 3600 + minutes * 60 + (seconds || 0);
  };

  // Compare current time and threshold time
  const checkTimeThreshold = (currentTime, thresholdTime) => {
    const currentSeconds = convertTimeToSeconds(currentTime);
    const thresholdSeconds = convertTimeToSeconds(thresholdTime);

    // Update state based on comparison
    setOverTimeNear(currentSeconds < thresholdSeconds);
  };

  useEffect(() => {
    const thresholdTime = '3:59:59'; // Threshold time

    // Run check initially and whenever timeLeftCount changes
    checkTimeThreshold(timeLeftCount, thresholdTime);
  }, [timeLeftCount]); // Add timeLeftCount as a dependency

  // Function to update window width and set the word limit based on it
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 2000) {
        setWordLimitCurretWork(42);
        setWordLimit(35);
      } else if (window.innerWidth > 1800) {
        setWordLimitCurretWork(37);
        setWordLimit(28);
      } else if (window.innerWidth > 1600) {
        setWordLimitCurretWork(27);
        setWordLimit(18);
      } else if (window.innerWidth > 1400) {
        setWordLimitCurretWork(22);
        setWordLimit(16);
      } else if (window.innerWidth > 1279) {
        setWordLimitCurretWork(20);
        setWordLimit(12);
      } else if (window.innerWidth > 1100) {
        setWordLimitCurretWork(100);
        setWordLimit(95);
      } else if (window.innerWidth > 900) {
        setWordLimitCurretWork(77);
        setWordLimit(72);
      } else if (window.innerWidth > 700) {
        setWordLimitCurretWork(50);
        setWordLimit(40);
      } else {
        setWordLimitCurretWork(25);
        setWordLimit(15);
      }
    };

    // Call handleResize initially to set the initial state
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    dispatch(resetEditorState());
  }, []);

  return (
    <>
      {loadingProofreaderWidgetCount ? (
        <div className="dashboard-loading-part">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <Row className="mb-3">
            <Col className="fnt-20 fw-semibold">Today's Report</Col>
            <Col className="fnt-18 fw-medium text-end">{moment().format('dddd, MMMM DD, YYYY')}</Col>
          </Row>
          <Row>
            <Col className="mb-3">
              <div className="customRow">
                <div className="customCol mb-3">
                  <div className="card-widget">
                    <div className="card-widget-header">
                      <div className="card-widget-title">Most Important</div>
                      {dashboardProofreaderFileCountData?.TodayWork?.UserFileName && (
                        <div className="fnt-14">
                          <CustomTooltips
                            title={dashboardProofreaderFileCountData?.TodayWork?.UserFileName}
                            placement="bottom"
                          >
                            {truncateString(
                              dashboardProofreaderFileCountData?.TodayWork?.UserFileName,
                              wordLimitCurretWork,
                            )}
                          </CustomTooltips>
                        </div>
                      )}
                      <div style={{ width: 130, height: 130 }} className="mx-auto my-3">
                        {dashboardProofreaderFileCountData?.TodayWork === null ? (
                          <CircularProgressbar
                            value={dashboardProofreaderFileCountData?.TodayWork?.CompletedPercentage || 0}
                            text={`${dashboardProofreaderFileCountData?.TodayWork?.CompletedPercentage || 0}%`}
                            strokeWidth={20}
                            styles={buildStyles({
                              strokeLinecap: 'butt',
                              textColor: '#2b2b67',
                              pathColor: '#2b2b67',
                              trailColor: '#2D9CDB26',
                            })}
                          />
                        ) : (
                          <CircularProgressbar
                            value={dashboardProofreaderFileCountData?.TodayWork?.CompletedPercentage || 0}
                            text={`${dashboardProofreaderFileCountData?.TodayWork?.CompletedPercentage || 0}%`}
                            strokeWidth={20}
                            styles={buildStyles({
                              strokeLinecap: 'butt',
                              textColor:
                                dashboardProofreaderFileCountData?.TodayWork === undefined ||
                                dashboardProofreaderFileCountData?.TodayWork === null
                                  ? '#2b2b67'
                                  : !timeLeftMinus && overTimeNear === false
                                    ? '#2b2b67'
                                    : '#f17f7f',
                              pathColor:
                                dashboardProofreaderFileCountData?.TodayWork === undefined ||
                                dashboardProofreaderFileCountData?.TodayWork === null
                                  ? '#2b2b67'
                                  : !timeLeftMinus && overTimeNear === false
                                    ? '#2b2b67'
                                    : '#f17f7f',
                              trailColor:
                                dashboardProofreaderFileCountData?.TodayWork === undefined ||
                                dashboardProofreaderFileCountData?.TodayWork === null
                                  ? '#2D9CDB26'
                                  : !timeLeftMinus && overTimeNear === false
                                    ? '#2D9CDB26'
                                    : '#dfcccc',
                            })}
                          />
                        )}
                      </div>
                      {dashboardProofreaderFileCountData?.TodayWork === undefined ||
                      dashboardProofreaderFileCountData?.TodayWork === null ? (
                        <div>
                          <p className="fnt-12 text-center">No progress to show, You have finished all the files</p>
                          <div className="d-flex justify-content-center flex-wrap gap-3">
                            <div
                              className="work-btn text-center"
                              style={{
                                backgroundColor: '#2b2b67',
                                border: '#2b2b67',
                                color: 'white',
                                width: '110px',
                              }}
                              onClick={() => {
                                setClaimFile(false);
                                setFullQcClick(false);
                                setQcClick(false);
                                setDueInDayClick(false);
                                setDueInHalfDayClick(false);
                                setLegalClick(false);
                                navigate(ALL_FILE_ROUTE);
                              }}
                            >
                              Claim New Files
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center flex-wrap gap-3">
                          <div
                            className="date-options text-center"
                            style={{
                              borderColor: !timeLeftMinus && overTimeNear === false ? '#2b2b67' : '#f17f7f',
                              borderWidth: '1px',
                              borderStyle: 'solid',
                              width: '170px',
                            }}
                          >
                            {!timeLeftMinus ? 'Due in' : 'Overdue by'}{' '}
                            {timeLeft === 'NaN:NaN:NaN' ? '00:00:00 Hrs' : timeLeft}
                          </div>
                          <div
                            className="work-btn"
                            style={{
                              backgroundColor: !timeLeftMinus && overTimeNear === false ? '#2b2b67' : '#f17f7f',
                            }}
                            onClick={() => {
                              if (dashboardProofreaderFileCountData?.TodayWork?.AudioFileId) {
                                if (
                                  dashboardProofreaderFileCountData?.TodayWork?.AudioFileId !== null &&
                                  dashboardProofreaderFileCountData?.TodayWork?.AudioFileId !== undefined
                                ) {
                                  setClaimFile(false);
                                  trackEvent('file_resume', {
                                    file_id: dashboardProofreaderFileCountData?.TodayWork?.AudioFileId,
                                    file_name: dashboardProofreaderFileCountData?.TodayWork?.UserFileName,
                                  });
                                  navigate(
                                    dashboardProofreaderFileCountData?.TodayWork?.AudioFileId
                                      ? `/${window.endPoint.IS_SLATE ? 'editor-copy' : 'editor'}/${dashboardProofreaderFileCountData?.TodayWork?.AudioFileId}`
                                      : DASHBOARD_ROUTE,
                                  );
                                  if (userInfo?.LevelName === 'Level 1' || userInfo?.LevelName === 'level 1') {
                                    setTodayWorkClick(true);
                                  }
                                }
                              }
                            }}
                          >
                            Resume Work
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="customCol mb-3">
                  <div className="card-widget">
                    <span>
                      <div className="card-widget-header d-flex align-items-center justify-content-between">
                        <div className="card-widget-title">Files due in 12Hrs</div>
                        {dashboardDataFileDueHalfDay?.dueinHalfDay?.Files.length > 1 && (
                          <span
                            className="link-color fw-normal fnt-14 cursor-pointer"
                            onClick={() => {
                              setDueInHalfDayClick(true);
                              setDueInDayClick(false);
                              setFullQcClick(false);
                              setQcClick(false);
                              setLegalClick(false);
                              navigate(MY_FILE_ROUTE);
                            }}
                          >
                            View All
                          </span>
                        )}
                      </div>
                      <div className="fnt-14 mb-3">in My Files</div>
                      {dashboardDataFileDueHalfDay?.dueinHalfDay?.Files.length === 0 ||
                      dashboardDataFileDueHalfDay?.dueinHalfDay?.Files === undefined ? (
                        <div className="d-flex justify-content-center align-items-center h-75 w-100 files-due-12hrs-no-data">
                          No Data Found
                        </div>
                      ) : (
                        <div className="recording-item-group">
                          {dashboardDataFileDueHalfDay &&
                            dashboardDataFileDueHalfDay?.dueinHalfDay?.Files.length !== 0 &&
                            dashboardDataFileDueHalfDay?.dueinHalfDay?.Files.slice(0, 2).map((data, index) => {
                              return (
                                <div className="recording-item" key={index}>
                                  <div className="d-flex align-items-center">
                                    <div className="recording-folder-icon">
                                      <FolderOutlinedIcon className="fnt-17" />
                                    </div>
                                    <div className="fnt-13 fw-medium me-2">
                                      <CustomTooltips title={data?.UserFileName} placement="bottom">
                                        {truncateString(data?.UserFileName, wordLimit)}
                                      </CustomTooltips>
                                      <div className="opacity-75 fnt-12">Time Left {data?.TimeLeft}</div>
                                    </div>
                                  </div>
                                  <div>
                                    <span
                                      className="btn btn-outline-primary fnt-14 fw-medium"
                                      style={{ padding: '6px 10px' }}
                                      onClick={() => {
                                        setClaimFile(false);
                                        if (data?.Id !== null && data?.Id !== undefined) {
                                          navigate(
                                            data?.Id
                                              ? `/${window.endPoint.IS_SLATE ? 'editor-copy' : 'editor'}/${data?.Id}`
                                              : DASHBOARD_ROUTE,
                                          );
                                          setTodayWorkClick(false);
                                        }
                                      }}
                                    >
                                      Resume
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </span>
                  </div>
                </div>
                <div className="customCol mb-3">
                  <span
                    style={{ position: 'relative' }}
                    onClick={() => {
                      setDueInDayClick(true);
                      setFullQcClick(false);
                      setQcClick(false);
                      setDueInHalfDayClick(false);
                      setLegalClick(false);
                      setFilterApiCall(true);
                      navigate(ALL_FILE_ROUTE);
                    }}
                  >
                    <div
                      className="file-info-wrapper mb-3"
                      style={{
                        border: '1.2px solid #0000001a',
                        borderRadius: '10px',
                        boxShadow: '0 4px 20px 0 #eeeeee80',
                      }}
                    >
                      <div className="file-info-icon">
                        <img src={due_file_icon} alt="due file" className="img-fluid" />
                      </div>
                      <div className="fnt-18 fw-bold">
                        Due in 24Hrs
                        <div className="fnt-16 fw-normal">in All Files</div>
                      </div>
                    </div>
                    <h4
                      style={{
                        position: 'absolute',
                        right: '26px',
                        bottom: window.innerWidth > 1500 ? '36px' : '26px',
                        cursor: 'pointer',
                      }}
                    >
                      {(!loadingProofreaderWidgetCount && dashboardProofreaderFileCountData
                        ? dashboardProofreaderFileCountData?.FileCounts?.DueFileCount
                        : 0) || 0}
                    </h4>
                  </span>
                  <span
                    style={{ position: 'relative' }}
                    onClick={() => {
                      setQcClick(true);
                      setLegalClick(false);
                      setDueInDayClick(false);
                      setFullQcClick(false);
                      setDueInHalfDayClick(false);
                      setFilterApiCall(true);
                      navigate(ALL_FILE_ROUTE);
                    }}
                  >
                    <div
                      className="file-info-wrapper"
                      style={{
                        border: '1.2px solid #0000001a',
                        borderRadius: '10px',
                        boxShadow: '0 4px 20px 0 #eeeeee80',
                      }}
                    >
                      <div className="file-info-icon">
                        <img src={qc_file_icon} alt="qc file" className="img-fluid" />
                      </div>
                      <div className="fnt-18 fw-bold">
                        QC Files
                        <div className="fnt-16 fw-normal">in All Files</div>
                      </div>
                    </div>
                    <h4
                      style={{
                        position: 'absolute',
                        right: '26px',
                        bottom: window.innerWidth > 1500 ? '36px' : '26px',
                        cursor: 'pointer',
                      }}
                    >
                      {!loadingProofreaderWidgetCount && dashboardProofreaderFileCountData
                        ? dashboardProofreaderFileCountData?.FileCounts?.QCFileCount
                        : 0 || 0}
                    </h4>
                  </span>
                </div>
                <div className="customCol mb-3">
                  <span
                    style={{ position: 'relative' }}
                    onClick={() => {
                      setFullQcClick(true);
                      setQcClick(false);
                      setDueInDayClick(false);
                      setDueInHalfDayClick(false);
                      setLegalClick(false);
                      setFilterApiCall(true);
                      navigate(ALL_FILE_ROUTE);
                    }}
                  >
                    <div
                      className="file-info-wrapper mb-3"
                      style={{
                        border: '1.2px solid #0000001a',
                        borderRadius: '10px',
                        boxShadow: '0 4px 20px 0 #eeeeee80',
                      }}
                    >
                      <div className="file-info-icon">
                        <img src={full_qc_file_icon} alt="full qc file" className="img-fluid" />
                      </div>
                      <div className="fnt-18 fw-bold">
                        Full QC Files
                        <div className="fnt-16 fw-normal">in All Files</div>
                      </div>
                    </div>
                    <h4
                      style={{
                        position: 'absolute',
                        right: '26px',
                        bottom: window.innerWidth > 1500 ? '36px' : '26px',
                        cursor: 'pointer',
                      }}
                    >
                      {(!loadingProofreaderWidgetCount && dashboardProofreaderFileCountData
                        ? dashboardProofreaderFileCountData?.FileCounts?.FullQCFileCount
                        : 0) || 0}
                    </h4>
                  </span>
                  <span
                    style={{ position: 'relative' }}
                    onClick={() => {
                      setLegalClick(true);
                      setDueInDayClick(false);
                      setFullQcClick(false);
                      setQcClick(false);
                      setDueInHalfDayClick(false);
                      setFilterApiCall(true);
                      navigate(ALL_FILE_ROUTE);
                    }}
                  >
                    <div
                      className="file-info-wrapper"
                      style={{
                        border: '1.2px solid #0000001a',
                        borderRadius: '10px',
                        boxShadow: '0 4px 20px 0 #eeeeee80',
                      }}
                    >
                      <div className="file-info-icon">
                        <img src={legal_file_icon} alt="legal file" className="img-fluid" />
                      </div>
                      <div className="fnt-18 fw-bold">
                        Legal Files
                        <div className="fnt-16 fw-normal">in All Files</div>
                      </div>
                    </div>
                    <h4
                      style={{
                        position: 'absolute',
                        right: '26px',
                        bottom: window.innerWidth > 1500 ? '36px' : '26px',
                        cursor: 'pointer',
                      }}
                    >
                      {(!loadingProofreaderWidgetCount && dashboardProofreaderFileCountData
                        ? dashboardProofreaderFileCountData?.FileCounts?.LegalFileCount
                        : 0) || 0}
                    </h4>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col style={{ marginBottom: 50 }}>
              <div className="card-widget ">
                <div className="card-widget-header d-flex align-items-center justify-content-between pb-4 ">
                  <div className="card-widget-title">All Files</div>
                  <div className="dashboard-table">
                    <button
                      className="filter-btn cursor-pointer"
                      onClick={handleShowProofReaderAllFileFilter}
                      disabled={loading !== false}
                      style={{
                        height: '50px',
                        width: '50px',
                        color: '#0f3659',
                        background: 'transparent',
                      }}
                    >
                      <Badge color="primary" variant="dot" invisible={!isFilterApplied}>
                        <TuneRoundedIcon />
                      </Badge>
                    </button>
                    <button
                      onClick={() => {
                        setFullQcClick(false);
                        setQcClick(false);
                        setDueInDayClick(false);
                        setDueInHalfDayClick(false);
                        setLegalClick(false);
                        navigate(ALL_FILE_ROUTE);
                        setFilterApiCall(true);
                      }}
                      className="expand-link px-2"
                    >
                      <LaunchRoundedIcon className="fnt-16" /> Expand
                    </button>
                  </div>
                </div>
                <CustomTable
                  tableData={allFilesDashboardProofreaderTableData}
                  filteredCustomers={proofreaderAllFileTable ? proofreaderAllFileTable?.Files : []}
                  totalRecords={proofreaderAllFileTable?.NoOfRecords}
                  rowsPerPage={rowsPerPage}
                  sortOrder={sortOrder}
                  sortField={sortField}
                  setRowsPerPage={setRowsPerPage}
                  handleSortChange={handleSortChange}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  setFilterApiCall={setFilterApiCall}
                  loading={loading}
                  checkbox={false}
                  bodyTemplates={bodyTemplates}
                  pageName="Dashsboard"
                />
              </div>
            </Col>
          </Row>
          <Modal
            show={proofReaderAllFileFilterModal}
            onHide={handleCloseProofReaderAllFileFilter}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName="custom-modal"
          >
            <div>
              <div className="preview-dropdown-header">
                Filter By
                <HighlightOffRoundedIcon
                  onClick={handleCloseProofReaderAllFileFilter}
                  className="cursor-pointer opacity-50"
                  style={{ height: '28px', width: '28px' }}
                />
              </div>
              <div className="preview-dropdown-body">
                <Row>
                  <Col md="6" className="mb-3">
                    <label>Client</label>
                    <Select
                      value={
                        filterClientData
                          ? {
                              value: filterClientData,
                              label:
                                filterDataFile?.UserList.find((option) => option.Id === filterClientData)?.Name ||
                                'Select Client',
                            }
                          : null
                      }
                      onChange={(selectedOption) => setFilterClientData(selectedOption?.value)}
                      options={filterDataFile?.UserList.map((option) => ({
                        value: option.Id,
                        label: option.Name,
                      }))}
                      isSearchable
                      placeholder="Select Client"
                      classNamePrefix="custom-select"
                      styles={{
                        control: (base) => ({
                          ...base,
                          height: '50px',
                          minWidth: '200px',
                          border: '1px solid #e6e6e6',
                          borderRadius: '4px',
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999, // Ensure the dropdown is above the modal
                        }),
                      }}
                      menuPortalTarget={document.body} // Render dropdown outside the modal
                    />
                  </Col>
                  <Col md="6" className="mb-3">
                    <label>Vendor</label>
                    <Select
                      value={
                        filterVendorData
                          ? {
                              value: filterVendorData,
                              label:
                                filterDataFile?.VendorList.find((option) => option.Id === filterVendorData)?.Name ||
                                'Select Vendor',
                            }
                          : null
                      }
                      onChange={(selectedOption) => setFilterVendorData(selectedOption?.value)}
                      options={filterDataFile?.VendorList.map((option) => ({
                        value: option.Id,
                        label: option.Name,
                      }))}
                      isSearchable
                      placeholder="Select Vendor"
                      classNamePrefix="custom-select"
                      styles={{
                        control: (base) => ({
                          ...base,
                          height: '50px',
                          minWidth: '200px',
                          border: '1px solid #e6e6e6',
                          borderRadius: '4px',
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999, // Ensure the dropdown is above the modal
                        }),
                      }}
                      menuPortalTarget={document.body} // Render dropdown outside the modal
                    />
                  </Col>
                  <Col md="6" className="mb-3">
                    <label>Language</label>
                    <Select
                      value={
                        filterLanguageData
                          ? {
                              value: filterLanguageData,
                              label: filterLanguageData,
                            }
                          : null
                      }
                      onChange={(selectedOption) => setFilterLanguageData(selectedOption?.value)}
                      options={filterDataFile?.LanguageList.map((option) => ({
                        value: option.Name,
                        label: option.Name,
                      }))}
                      isSearchable
                      placeholder="Select Language"
                      classNamePrefix="custom-select"
                      styles={{
                        control: (base) => ({
                          ...base,
                          height: '50px',
                          minWidth: '200px',
                          border: '1px solid #e6e6e6',
                          borderRadius: '4px',
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999, // Ensure the dropdown is above the modal
                        }),
                      }}
                      menuPortalTarget={document.body} // Render dropdown outside the modal
                    />
                  </Col>
                  <Col md="6" className="mb-3">
                    <label>Service</label>
                    <Form.Select
                      aria-label="Default select example"
                      value={filterServiceData}
                      onChange={(e) => setFilterServiceData(e.target.value)}
                    >
                      <option value="">Select Service</option>
                      {filterDataFile &&
                        filterDataFile?.ServiceList.map((option, index) => (
                          <option key={index} value={option.Id}>
                            {option.Name}
                          </option>
                        ))}
                    </Form.Select>
                  </Col>
                  {/* <Col md="6" className="mb-3">
                    <StatusDropdown
                      filterFilesStatusData={filterFilesStatusData}
                      setFilterFilesStatusData={setFilterFilesStatusData}
                      isShowCompleted={false}
                    />
                  </Col> */}
                  <Col md="12" className="text-end mt-5">
                    <Button
                      variant="outline-secondary"
                      onClick={handleFilterClear}
                      className="me-2"
                      style={{ height: '45.49px', fontWeight: 600 }}
                    >
                      Clear Filter
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => {
                        trackEvent('file_filter', {
                          page: 'all_files',
                          client: filterClientData,
                          vendor: filterVendorData,
                          language: filterLanguageData,
                          service: filterServiceData,
                        });
                        handleFilter();
                      }}
                      className="ms-2"
                      style={{ height: '45.49px', fontWeight: 600 }}
                    >
                      Filter
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          </Modal>
          <Modal
            show={proofReaderMyFileMetricsModal}
            onHide={handleCloseProofReaderMyFileMetrics}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName="custom-modal"
          >
            <div>
              <div className="preview-dropdown-header">
                Metrics
                <HighlightOffRoundedIcon
                  onClick={handleCloseProofReaderMyFileMetrics}
                  className="cursor-pointer opacity-50"
                  style={{ height: '28px', width: '28px' }}
                />
              </div>
              <div className="preview-dropdown-body">
                <div
                  className="text-end"
                  onClick={() => window.open(FAQ, '_blank')}
                  style={{
                    textDecoration: 'underline',
                    color: '#190041',
                    cursor: 'pointer',
                    marginBottom: '6px',
                  }}
                >
                  FAQ
                </div>
                <div className="mb-4">
                  <div className="card-widget">
                    <CustomTable
                      tableData={myStatsTableData}
                      filteredCustomers={myMetrics ? myMetrics : []}
                      loading={loadingMetrics}
                      checkbox={false}
                      pagination={false}
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <div className="card-widget">
                    <RatingMetrics loading={loading} ratingMetrics={ratingMetrics} />
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default Dashboard;
